
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PaymentReportModal extends Vue {
  @Prop({ default: false })
  show!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: "" })
  error!: string;

  startDate = "";
  endDate = "";

  @Watch("show")
  onShowChange(newVal: boolean) {
    if (newVal) {
      this.initializeDates();
    }
  }

  initializeDates() {
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);

    // Format dates as YYYY-MM-DD
    this.endDate = this.formatDate(today);
    this.startDate = this.formatDate(oneMonthAgo);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  onStartDateChange(value: string) {
    this.startDate = value;
  }

  onEndDateChange(value: string) {
    this.endDate = value;
  }

  handleCancel() {
    this.$emit("cancel");
  }

  handleProceed() {
    if (!this.startDate || !this.endDate) {
      return;
    }
    this.$emit("proceed", {
      start: this.startDate,
      end: this.endDate,
    });
  }
}
